import { styles } from "@repo/helpers";

import { InputComponent } from "../input";
import style from "./style.module.scss";
import { MarkupProps } from "./types";

export default function TextAreaMarkup(props: MarkupProps) {
	const { rows, cols, onChange, inputRef, ...inputProps } = props;
	const { className, error, id, name, value, disabled, onKeyDown, readOnly } = inputProps;
	const adjProps = {
		className: styles(className, style.formControl, error && style.error, disabled && style.disabled),
		name: name || id,
		id: id,
		value: value ?? "",
		disabled: disabled,
		readOnly: readOnly,
		rows: rows,
		cols: cols,
		onChange: onChange,
		onKeyDown: onKeyDown,
	};
	return (
		<InputComponent {...inputProps}>
			<textarea {...adjProps} ref={inputRef} />
		</InputComponent>
	);
}
